import o from"./Core";import r from"./Plugin";export default o;export{r as Plugin};